export class TaskMassAssignPopupManager {

    constructor(private containerElement: JQuery) { }

    private setDueDateSwitch : JQuery<HTMLElement>;
    private dueDateInput : JQuery<HTMLElement>;

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.setDueDateSwitch = self.containerElement.find('#set-due-date-switch');

        console.log(self.setDueDateSwitch);

        self.dueDateInput = self.containerElement.find('#due-date-input');
    }

    private bindEvents() {
        var self = this;

        var form =  this.containerElement.find('form');
        var submitButton = form.find(':submit');

        submitButton.off('click').on('click', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();

            submitButton.prop('disabled', true);
            form.trigger('submit');
        }) 

        self.setDueDateSwitch.off('change').on('change', () => {
            var checked = self.setDueDateSwitch.is(':checked');

            console.log(checked);

            self.dueDateInput.prop("disabled", !checked);
            self.dueDateInput.prop("required", checked);
        })
    }
}